$(".open").on("click", function(){
    $(".popup-overlay, .popup-content, .close_btn, .close_btn_top, .lp_container, .under_header_section, .add_image").addClass("active");
    $("html,body").addClass("bg-overlay");
    $(".text_box, .lp_container img, .card_contents").addClass("popup-content");
  });

  $(".close, .popup-overlay, .bg-overlay").on("click", function(){
    $(".popup-overlay, .popup-content, .bg-overlay, .close_btn, .close_btn_top, .lp_container, .under_header_section, .add_image").removeClass("active bg-overlay");
    $(".text_box, .lp_container img, .card_contents").removeClass("popup-content");
  });
$(".order_open").on("click", function(){
    $(".order-popup-overlay, .popup-content, .close_btn, .close_btn_top").addClass("active");
    $("html,body").addClass("bg-overlay");
    $(".text_box, .lp_container img, .card_contents").addClass("popup-content");
  });

  $(".close, .order-popup-overlay, .bg-overlay").on("click", function(){
    $(".order-popup-overlay, .popup-content, .bg-overlay, .close_btn, .close_btn_top").removeClass("active bg-overlay");
    $(".text_box, .lp_container img, .card_contents").removeClass("popup-content");
  });

  $(".btn_content a").on("click", function(){
    $(".btn_content").addClass("display_none");
  });
  $(".close_btn, .close_btn_top").on("click", function(){
    $(".btn_content").removeClass("display_none");
  });
  // document.getElementById("popup_top").addEventListener("click", function () {
  //   location.replace("https://umaca-meal.com/pages/osechi");
  // }, false);
  
//リロード
window.onpageshow = function(event) {
  if (event.persisted) {
           window.location.reload();
  }

};
    // let Locate = $('.popup-content').offset().top;

    // $('#items_btn').click(function(){
    //     $(window).scrollTop(Locate);
    // });

  
  // $("#items_btn").on("click", function () {
  //   let elmHash = $(this).attr('#popup-fixed'); //ページ内リンクのHTMLタグhrefから、リンクされているエリアidの値を取得
  //   let pos = $(elmHash).offset().top;	//idの上部の距離を取得
  //   $('body,html').animate({scrollTop: pos}, 500); //取得した位置にスクロール。500の数値が大きくなるほどゆっくりスクロール
  //   return false;
  // });

  {
    //Intersection Observer API
  function callback(entries, obs){
    entries.forEach(entry => {
      if(!entry.isIntersecting){
        return;
      }
      entry.target.classList.add('appear');
      obs.unobserve(entry.target);
    });
  }
  
  const options = {
    threshold: 0.2,
  };
  
    const observer =  new IntersectionObserver(callback, options);
  
    const targets = document.querySelectorAll('.animate');
    targets.forEach(target => {
      observer.observe(target);
    });
  }

/* 改変 */

// $(function(){
//     $('.nav-open').hover(function(e){
//       e.preventDefault();
//         $(this).toggleClass('active');
//         $(this).next('nav.nav-menu').slideToggle();
//     });
// });

